/* ============
 * Actions for the notification module
 * ============
 *
 * The actions that are available on the
 * notification module.
 */

import {
  CLEAR_ACTIVE_QUEUE,
  FILL_ACTIVE_QUEUE,
  PUSH,
  START_PULLING,
  STOP_PULLING
} from './mutation-types.js'

export default {
  push,
  pull
}

function push({ dispatch, commit, state }, message) {
  commit(PUSH, message)

  dispatch('pull', { commit, state })
}

function pull({ commit, state }, options = {}) {
  if (state.pulling && !options.force) {
    return
  }
  commit(START_PULLING)

  commit(CLEAR_ACTIVE_QUEUE)
  commit(FILL_ACTIVE_QUEUE)

  const { waitingQueue, activeQueue } = state

  if (waitingQueue.length || activeQueue.length) {
    setTimeout(() => pull({ commit, state }, { force: true }), 2000)
  } else {
    commit(STOP_PULLING)
  }
}
